
import Vue from 'vue'
import { permitCountyFormatServer } from "./permitCountyFormatServer";

const getDefaultState = () => {
    return {
        permitCounty: {
            id: 0,
            name: "",
            status: 0,
            listItem: [],
            listCity: [],
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List(_, filterPublicCountys = false) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`permitCounty/list/${filterPublicCountys}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listPermitCounty = result.data.result;

                return listPermitCounty;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list permit county: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$vanKirkApi.get(`permitCounty/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Error to get permit county`
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                result: `Error to get permit county: [${ex}]`
            };
        }
    },

    async CreateUpdate(_, permitCountyRequest) {

        try {
            let permitCountyRequestFormated = permitCountyFormatServer(JSON.parse(JSON.stringify(permitCountyRequest)));

            const result = await Vue.prototype.$vanKirkApi.post(`permitCounty/create-update`, permitCountyRequestFormated,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let msg = "Register updated with success!";

                if (permitCountyRequest.id === 0) {
                    msg = "Record created successfully";
                }

                return {
                    id: result.data.result,
                    success: true,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: "Error to create/update register!"
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `Error to create/update register: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `Error to create/update register: [${error}]`
                };
            }
        }
    },

    async UpdateStatus(_, { id, statusId }) {

        try {
            const result = await Vue.prototype.$vanKirkApi.put(`permitCounty/update-status/${id}/${statusId}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "Status updated with success!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Error updating the status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error updating the status: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.permitCounty, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.permitCounty;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
